import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';

class UserService {
    private static readonly API_PATH = '/identity/v0/users/@self';

    public loadUserDetails() {
        return HTTP_SERVICE_INSTANCE.getAxios().get<DisguiseDto.UserDataDto>(UserService.API_PATH);
    }

    public getFullApiPath() {
        return UserService.API_PATH;
    }
}

const USER_SERVICE_INSTANCE = new UserService();

export {USER_SERVICE_INSTANCE};
